module.exports = __webpack_public_path__ + "img/80.5.COD.41ce5c7e.png";